import { Text } from '@atlaskit/primitives/compiled';

export const AssessmentRecommendationTrustedHtml = ({ html }: { html: string }) => (
	<Text>
		<span
			// eslint-disable-next-line react/no-danger -- FastShift recommendation HTML is trusted server-authored content.
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	</Text>
);
